<template>
  <ECard
    v-if="show"
    :elevation="0"
    class="tours-activities-ads"
    as="div"
  >
    <div class="tours-activities-ads__content">
      <div class="tours-activities-ads__header">
        <EHeading
          as="h3"
          class="tours-activities-ads__title"
          data-test-id="tours-activities-ads__title"
        >
          {{ title }}
        </EHeading>
        <EAdLabel
          class="tours-activities-ads__ad-label"
          data-test-id="tours-activities-ads__ad-label"
          tooltip-side="left-center"
          @report-clicked="onAdReportClick"
        >
          {{ $t('common.search.results.toursactivitiesads.label') }}
        </EAdLabel>
      </div>
      <EAdQualityFeedbackLink
        ref="ad-report"
        :widget-type="'tours-activities-ad_result'"
        class="tours-activities-ads__report-link"
        data-test-id="tours-activities-ads__feedback-link"
      />
      <ul class="tours-activities-ads__list">
        <li
          v-for="(item, index) in itemsToShow"
          :key="index"
          class="tours-activities-ads__item"
          data-test-id="tours-activities-ads__item"
        >
          <ETourActivityAdsItem
            v-bind="item"
            :page-position="pagePosition"
            :rank="index + 1"
            :source="item.url"
          />
        </li>
      </ul>
    </div>
  </ECard>
</template>

<script>
import { mapGetters } from 'vuex';
import ECard from '~~/common/vue/components/card';
import ETourActivityAdsItem from './item';
import EAdLabel from '~~/common/vue/components/ad-label';
import EHeading from '~~/common/vue/components/heading';
import EAdQualityFeedbackLink from '~~/search/common/vue/components/ad-quality-feedback-link';
import { toursActivitiesAdFormat } from '~~/common/js/constants/feature-flags';

// max limit of items to show according to Bing API requirements
export const MAX_ITEM_LIMIT = 3;

export default {
  name: 'ETourActivityAds',
  components: {
    ECard,
    ETourActivityAdsItem,
    EAdLabel,
    EHeading,
    EAdQualityFeedbackLink,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pagePosition: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['hasSidebarAds', 'hasSidebarProductAds', 'hasSidebarEntities']),
    ...mapGetters('unleash', ['getFeatureToggle']),
    flagActive() {
      return this.getFeatureToggle(toursActivitiesAdFormat.flag)?.value ===
             toursActivitiesAdFormat.enabled;
    },
    show() {
      return this.hasItems && this.flagActive;
    },
    title() {
      return this.$t('common.search.results.toursactivitiesads.title');
    },
    hasItems() {
      return this.items?.length > 0;
    },
    itemsToShow() {
      return this.items.slice(0, MAX_ITEM_LIMIT);
    },
  },
  methods: {
    onAdReportClick() {
      this.$refs['ad-report']?.$el.click();
    },
  },
};
</script>

<style lang="scss" scoped>
.tours-activities-ads {
  @include desktop {
    border: solid $border-width var(--color-decorative-border-1);
  }
}

.tours-activities-ads__content {
  display: flex;
  flex-direction: column;
  gap: $space-1s;
  padding: $space-m $space-m $space-1s;
}

.tours-activities-ads__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.tours-activities-ads__title {
  @include line-clamp(1);

  font-size: $font-m;
  font-weight: $font-weight-m;
  color: var(--color-text-secondary);
}

.tours-activities-ads__list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  .tours-activities-ads__item:not(:last-child) {
    @include divider(bottom);
  }
}
</style>
